/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CurrencyPlan } from '../models/CurrencyPlan';
import type { CurrencyPlanCreateRequest } from '../models/CurrencyPlanCreateRequest';
import type { Plan } from '../models/Plan';
import type { PlanMigrationAttributes } from '../models/PlanMigrationAttributes';
import type { PlanPublic } from '../models/PlanPublic';
import type { SurveyJobProfileMigrationConfig } from '../models/SurveyJobProfileMigrationConfig';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PlanService {

    /**
     * Get list of plans
     * @returns any Success
     * @throws ApiError
     */
    public static getPlansList({
        includeStats,
        current,
        inTransition,
        id,
        participationId,
        returnUnscoped,
        limit,
        offset,
    }: {
        /**
         * Flag to add stats to model
         */
        includeStats?: boolean,
        /**
         * Flag to get only current plan
         */
        current?: boolean,
        /**
         * Include plans in transition
         */
        inTransition?: boolean,
        /**
         * Filter by id
         */
        id?: Array<number>,
        /**
         * Filter by survey participation
         */
        participationId?: string,
        /**
         * Flag is return plans without default scope condition
         */
        returnUnscoped?: boolean,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        plans: Array<Plan>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plan',
            query: {
                'includeStats': includeStats,
                'current': current,
                'inTransition': inTransition,
                'id': id,
                'participationId': participationId,
                'returnUnscoped': returnUnscoped,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add a new plan
     * @returns any Success
     * @throws ApiError
     */
    public static addPlan({
        requestBody,
    }: {
        requestBody: {
            name?: string;
            type?: string;
            current?: boolean;
            deactivated?: boolean;
            effectiveDate?: string;
            employeeDataFileId?: number | null;
            salaryRangeFileId?: number | null;
            previousPlanId?: number | null;
            migrate?: Array<PlanMigrationAttributes>;
            surveyMigrationConfig?: Array<SurveyJobProfileMigrationConfig>;
        },
    }): CancelablePromise<{
        plan?: Plan;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get list of plans public info
     * @returns any Success
     * @throws ApiError
     */
    public static getPublicPlansList({
        includeStats,
        participationId,
        current,
        id,
        returnUnscoped,
        limit,
        offset,
    }: {
        /**
         * Flag to add stats to model
         */
        includeStats?: boolean,
        /**
         * Filter by survey participation
         */
        participationId?: string,
        /**
         * Flag to get only current plan
         */
        current?: boolean,
        /**
         * Filter by id
         */
        id?: Array<number>,
        /**
         * Flag to return plans without default scope condition (includes deactivated plans)
         */
        returnUnscoped?: boolean,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        plans: Array<PlanPublic>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plan/public',
            query: {
                'includeStats': includeStats,
                'participationId': participationId,
                'current': current,
                'id': id,
                'returnUnscoped': returnUnscoped,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get plan
     * @returns any Success
     * @throws ApiError
     */
    public static getPlan(): CancelablePromise<{
        plan?: Plan;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plan/{id}',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Plan's Information
     * @returns Plan Success
     * @throws ApiError
     */
    public static updatePlan({
        id,
        requestBody,
    }: {
        /**
         * Plan ID
         */
        id: number,
        requestBody?: {
            name?: string;
            effectiveDate?: string;
            employeeDataFileId?: number | null;
            salaryRangeFileId?: number | null;
            previousPlanId?: number | null;
        },
    }): CancelablePromise<Plan> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/plan/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete the plan
     * @returns any Success
     * @throws ApiError
     */
    public static deletePlan({
        id,
    }: {
        /**
         * Plan ID
         */
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/plan/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Plan's Deactivated flag
     * @returns Plan Success
     * @throws ApiError
     */
    public static deactivatePlan({
        id,
        requestBody,
    }: {
        /**
         * Plan ID
         */
        id: number,
        requestBody: {
            deactivated: boolean;
        },
    }): CancelablePromise<Plan> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/plan/{id}/active',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Set current plan
     * @returns Plan Success
     * @throws ApiError
     */
    public static setCurrentPlan({
        id,
        requestBody,
    }: {
        /**
         * Plan ID
         */
        id: number,
        requestBody: {
            current: boolean;
        },
    }): CancelablePromise<Plan> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/plan/{id}/current',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Currency Plan List
     * @returns CurrencyPlan Success
     * @throws ApiError
     */
    public static getCurrencyPlanList({
        id,
    }: {
        /**
         * Plan ID
         */
        id: number,
    }): CancelablePromise<Array<CurrencyPlan>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/plan/{id}/currency',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Currency Plan
     * @returns any Success
     * @throws ApiError
     */
    public static addCurrencyPlan({
        id,
        requestBody,
    }: {
        /**
         * Plan ID
         */
        id: number,
        requestBody: CurrencyPlanCreateRequest,
    }): CancelablePromise<{
        currencyPlan?: CurrencyPlan;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan/{id}/currency',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Currency Plan's Information
     * @returns CurrencyPlan Success
     * @throws ApiError
     */
    public static updateCurrencyPlan({
        id,
        currencyPlanId,
        requestBody,
    }: {
        /**
         * Plan ID
         */
        id: number,
        /**
         * Currency Plan ID
         */
        currencyPlanId: number,
        requestBody: {
            rate: number;
            isDefault?: boolean;
        },
    }): CancelablePromise<CurrencyPlan> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/plan/{id}/currency/{currencyPlanId}',
            path: {
                'id': id,
                'currencyPlanId': currencyPlanId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete the currency plan
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCurrencyPlan({
        id,
        currencyPlanId,
    }: {
        /**
         * Plan ID
         */
        id: number,
        /**
         * Currency Plan ID
         */
        currencyPlanId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/plan/{id}/currency/{currencyPlanId}',
            path: {
                'id': id,
                'currencyPlanId': currencyPlanId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export Currencies
     * @returns binary Success
     * @throws ApiError
     */
    public static exportCurrencies({
        id,
    }: {
        /**
         * Plan ID
         */
        id: number,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan/{id}/currency/export',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Replace survey in a plan
     * @returns any Success
     * @throws ApiError
     */
    public static replaceSurvey({
        id,
        requestBody,
    }: {
        /**
         * Plan ID
         */
        id: number,
        requestBody: {
            oldSurveyId?: string;
            newSurveyId?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan/{id}/replaceSurvey',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * reset composites
     * @returns any Success
     * @throws ApiError
     */
    public static resetComposites({
        id,
    }: {
        /**
         * Plan ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan/{id}/resetComposites',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Job Mappings
     * @returns any Success
     * @throws ApiError
     */
    public static deleteJobMappings({
        id,
        surveyJobProfileId,
    }: {
        /**
         * Plan ID
         */
        id: number,
        /**
         * Survey Job Profile ID
         */
        surveyJobProfileId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan/{id}/deleteJobMappings/{surveyJobProfileId}',
            path: {
                'id': id,
                'surveyJobProfileId': surveyJobProfileId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add a new plan transition
     * @returns any Success
     * @throws ApiError
     */
    public static addPlanTransition({
        requestBody,
    }: {
        requestBody: {
            name?: string;
            effectiveDate?: string;
            plan?: number;
            employeeDataFileId?: number | null;
            salaryRangeFileId?: number | null;
            migrate?: {
                paymarket?: boolean;
                currency?: boolean;
                dataCutMapping?: boolean;
                composite?: boolean;
                jobMapping?: boolean;
                levelMapping?: boolean;
                survey?: boolean;
            };
        },
    }): CancelablePromise<{
        plan?: Plan;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/plan/transition',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
